import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { forwardRef } from 'react';
import { StyledCheckbox, StyledFormControlLabel, StyledIcon } from './checkbox.styles';
import checkboxIcon from '@images/checkbox-icon.svg';
import { jsx as _jsx } from "react/jsx-runtime";
var Checkbox = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx(StyledFormControlLabel, {
    control: /*#__PURE__*/_jsx(StyledCheckbox, _objectSpread({
      ref: ref,
      icon: /*#__PURE__*/_jsx(StyledIcon, {
        src: checkboxIcon
      }),
      checkedIcon: /*#__PURE__*/_jsx(StyledIcon, {
        src: checkboxIcon
      }),
      indeterminateIcon: /*#__PURE__*/_jsx(StyledIcon, {
        src: checkboxIcon
      })
    }, props)),
    label: props.label
  });
});
Checkbox.displayName = 'Checkbox';
export { Checkbox };